rdefine("app/clients/LanguageForm",['backbone',
    'text!clients/languageform.html'],function(Backbone, template) {

    var LanguageFormItem = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'clients-language-form-item',
        smodel:null,
        field:'',
        bindings:{
            input:{
                attr:{
                    placeholder:'model.lang.name'
                }
            },
            label:{
                text:'model.lang.name'
            }
        },
        initialize:function(options) {
            this.field = options.field;
            this.smodel = options.smodel;
            this.$el.html(template);
            this.fieldname =  this.field + "." + this.model.get("language");

            this.$el.find("input").val(this.smodel.get(this.fieldname));

            this.smodel.on("change:" + this.fieldname, function() {
                this.$el.find("input").val(this.smodel.get(this.fieldname));
            }.bind(this));

            this.$el.find("input").on("change", function() {
                this.smodel.set(this.fieldname, this.$el.find("input").val());
            }.bind(this));

        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'clients-language-form',
        bindings:{
            el:{
                collection:{
                    col:'languages',
                    view: null
                }
            }
        },
        languages:null,
        initialize:function(options) {
            this.bindings.el.collection.view = function(opt) {
                opt.smodel = options.model;
                opt.field = options.field;
                return new LanguageFormItem(opt);
            }.bind(this);
            this.$el.addClass("clients-language-form");
            this.languages = options.languages;
        }
    });
});